import { createContext, useContext, useState } from "react";

const FixRequestContext = createContext();

export const FixRequestProvider = ({ children }) => {
    const [_categoryList, _setCategoryList] = useState({});/// ✅ 카테고리 리스트
    const [_selectCategory, _setSelectCategory] = useState({})/// ✅ 선택한 카테고리

    return (
        <FixRequestContext.Provider value={{ _categoryList, _setCategoryList, _selectCategory, _setSelectCategory }}>
            {children}
        </FixRequestContext.Provider>
    );
};

export const useFixRequest = () => useContext(FixRequestContext);
